import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

export function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label="Toggle theme"
      data-testid="theme-toggle"
      className={`inline-flex items-center justify-center w-10 h-10 border border-luxe hover:border-luxe-strong transition-colors ${className}`}
      style={{ background: "transparent", color: "var(--text-primary)" }}
    >
      {theme === "dark" ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
}
